import { Component, inject, input } from '@angular/core';
import { BasketService } from '@basket';
import { BadgeTextComponent, CardComponent, IconComponent } from '@components';
import { TranslatePipe, provideTranslationDictionaryMapping } from '@i18n';
import { translation } from '../../i18n/translation.constant';
import { PriceBandPipe } from '../../pipes/price-band/price-band.pipe';

@Component({
  selector: 'app-registered-appliance',
  imports: [
    BadgeTextComponent,
    CardComponent,
    IconComponent,
    PriceBandPipe,
    TranslatePipe,
  ],
  templateUrl: './registered-appliance.component.html',
  styleUrl: './registered-appliance.component.scss',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegisteredApplianceComponent {
  private readonly basketService = inject(BasketService);
  readonly selectedRegisteredAppliance =
    this.basketService.initialRegisteredAppliance;
  readonly startCollapsed = input<boolean>(true);
}
